// extracted by mini-css-extract-plugin
export default {"plan":"lO_Vufr8YFCP7VodQOA_","noWrap":"lEEUwRfVmx0SUXvt7seq","label":"s_nC0Yp8QvTAxhyiTLnS","content":"KS5Id3rwXXx9HKW_mvdR"};